class VendorsList extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = `
      <style>
        .vendor-hash-links {
          top: 0;
          width: 100%;
          z-index: 10;
          display: flex;
          position: sticky;
          column-gap: 1.6rem;
          padding: 2rem 0 3.5rem;
          justify-content: center;
          background-color: var(--hh-color-white);
        }

        .vendor-hash-link {
          text-decoration: none;
          color: var(--hh-color-black);
        }

        .vendor-hash-link:hover,
        .vendor-hash-link.active {
          color: var(--hh-color-green);
        }

        .vendors-list {
          overflow: auto;
          max-height: calc(100vh - 270px);
        }
        .vendors-list--inner {
          position: relative;
          padding: 0;
          margin: auto;
        }
        .organized-vendors {
          display: flex;
          padding: 3px 0;
          height: auto;
          position: relative;
        }
        .organized-vendors .section-title {
          width: 105px;
          padding-right: 20px;
          font: var(--hh-h5-font);
          color: var(--hh-color-black);
        }
        .organized-vendors .organized-vendors--elements {
          flex: 1;
          display: flex;
          flex-wrap: wrap;
        }
        .organized-vendors .vendor-list-item {
          margin: 0.25rem 0;
          flex: 0 0 33.333333%;
        }

        .organized-vendors .vendor-list-item a {
          width: 80%;
          margin: auto;
          height: auto;
          text-decoration: none;
          color: var(--hh-color-black);
        }
        .organized-vendors .vendor-list-item a:hover {
          text-decoration: underline;
          color: var(--hh-color-green);
        }

        .vertical-divider {
          top: 0;
          width: 1px;
          height: 100%;
          position: absolute;
          border-right: 1px solid rgba(0, 0, 0, 0.1);
        }

        .vertical-divider-1 {
          left: 95px;
        }

        .vertical-divider-2 {
          left: calc(80px + calc((100% - 95px) / 3));
        }

        .vertical-divider-3 {
          left: calc(70px + calc((100% - 95px) / 3) * 2);
        }




        span {
          text-align: left;
        }
      </style>

      <div class="vendors-list" id="vendors-list">
        <div class="vendors-list--inner"></div>
      </div>
    `;

    this.vendorsListElement = this.shadowRoot.querySelector('#vendors-list');
    this.vendorsListInnerElement = this.shadowRoot.querySelector('.vendors-list--inner');
    this.focusFirst = this.getAttribute('focus-first') === 'true';
  }

  connectedCallback() {
    this.buildVendorsNav();
    this.addEventListeners();
  }

  addEventListeners() {
    this.shadowRoot.addEventListener('click', (e) => {
      if (e.target.classList.contains('vendor-hash-link')) {
        e.preventDefault();
        const tempHash = e.target.getAttribute('href');
        const vendorItem = this.vendorsListInnerElement.querySelector(`[data-hash="${tempHash}"]`);

        if (vendorItem) {
          this.vendorsListElement.scrollTo({
            top: vendorItem.offsetTop,
            behavior: 'smooth'
          });
        }
      }
    });

    this.shadowRoot.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.classList.contains('vendor-hash-link')) {
        e.preventDefault();
        const tempHash = e.target.getAttribute('href');
        const vendorItem = this.vendorsListInnerElement.querySelector(`[data-hash="${tempHash}"]`);

        if (vendorItem) {
          this.vendorsListElement.scrollTo({
            top: vendorItem.offsetTop,
            behavior: 'smooth'
          });

          const firstLink = vendorItem.querySelector('a');
          if (firstLink) {
            firstLink.focus();
          }
        }
      }
    });

    this.vendorsListElement.addEventListener('scroll', () => {
      const organizedVendors = this.shadowRoot.querySelectorAll('.organized-vendors');
      const activeHashLink = this.shadowRoot.querySelector('.vendor-hash-link.active');

      for (const [idx, tpl] of Array.from(organizedVendors).entries()) {
        if (tpl.offsetTop > this.vendorsListElement.scrollTop) {
          const tempHash = organizedVendors[idx - 1].getAttribute('data-hash');
          const targetHashLink = this.shadowRoot.querySelector(`.vendor-hash-link[href="${tempHash}"]`);

          if (activeHashLink) activeHashLink.classList.remove('active');
          if (targetHashLink) targetHashLink.classList.add('active');
          break;
        }
      }
    });
  }

  buildVendorsNav() {
    const vendorsList = this.getAttribute('data-shop-vendors');
    const vendorsObject = {};
    let hashLink = "",
      pastFirstChar = "",
      hashLinks = document.createElement('div');
    hashLinks.classList.add('vendor-hash-links');

    const vendorsArray = this.getJson(vendorsList.replace("!@!", "'"));

    if (!vendorsArray) return false;

    vendorsArray.forEach((element) => {
      const firstChar = /[^A-Za-z]/.test(element.charAt(0)) ? '#' : element.charAt(0).toUpperCase();

      if (pastFirstChar !== firstChar) {
        hashLink = document.createElement('a');
        hashLink.classList.add('vendor-hash-link');
        hashLink.href = `#hash-${firstChar}`;
        hashLink.textContent = firstChar;
        hashLinks.appendChild(hashLink);
        pastFirstChar = firstChar;
      }

      if (!vendorsObject.hasOwnProperty(firstChar)) {
        vendorsObject[firstChar] = { 'elements': [] };
      }

      vendorsObject[firstChar]['elements'].push(element);
    });

    this.vendorsListElement.insertBefore(hashLinks, this.vendorsListInnerElement);

    Object.entries(vendorsObject).forEach(([key, obj]) => {
      const vendorsWrapper = document.createElement('div');
      vendorsWrapper.classList.add('organized-vendors');
      vendorsWrapper.setAttribute('data-hash', `#hash-${key}`);

      const sectionTitle = document.createElement('div');
      sectionTitle.classList.add('section-title');
      sectionTitle.innerHTML = `<span>${key}</span>`;
      vendorsWrapper.appendChild(sectionTitle);

      const vendorsElements = document.createElement('div');
      vendorsElements.classList.add('organized-vendors--elements');

      obj.elements.forEach((element) => {
        const listItem = document.createElement('div');
        listItem.classList.add('vendor-list-item');
        listItem.innerHTML = `<a href="/collections/vendors?q=${encodeURIComponent(element)}" title="${element}">${element}</a>`;
        vendorsElements.appendChild(listItem);
      });

      vendorsWrapper.appendChild(vendorsElements);
      this.vendorsListInnerElement.appendChild(vendorsWrapper);
    });


    for (let i = 1; i < 4; i++) {
      const divElement = document.createElement('div');
      divElement.classList.add('vertical-divider', `vertical-divider-${i}`);
      this.vendorsListInnerElement.appendChild(divElement);
    }

    if (this.focusFirst === true) {
      this.shadowRoot.querySelector('.vendor-hash-link').classList.add('active');
    }
    this.removeAttribute('data-shop-vendors');
  }

  getJson(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return false;
    }
  }
}

customElements.define('vendors-list', VendorsList);
